<mat-drawer-container class="countable-drawer">
    <mat-drawer-content class="overflow-hidden">
        <div class="page-wraper">
            <div class="page-title-block workbook-title-block align-items-start">
                                <div class="left-content title-block-left button-group flex-row header-actions">
                                    <button (click)="manualSync()" mat-button mat-stroked-button color="dark" class="btn-default-icon button-tooltip"
                                            title="Refresh">
                                        @if (isSyncCall()) {
                                            <span class="smooth-gradient-ring-s"></span>
                                        }@else{
                                            <i class="fa-regular fa-arrows-rotate"></i>
                                        }

                                    </button>
                                </div>

                <div class="title-block-middle flexbox-column gap-0 flex-1 align-items-center text-center">
                    <h3 class="title">{{ engagementScheduleDetails().engagementDetails.clientName }}</h3>
                    <h3 class="title">{{ scheduleName() }}</h3>
                    <h6 class="title hover-action d-flex flex-row align-items-center gap-8 text-center"
                        style="min-height:36px;">
                        <span>{{ engagementScheduleDetails().engagementDetails.yearEnd | appCountableTimeZone:'MMMM d, yyyy':'UTC' }}</span>
                    </h6>
                </div>

                <div class="title-block-right d-none d-lg-flex"></div>
            </div>
            <app-view-schedule (scheduleSync)="updateSyncCall($event)"
                               class="d-flex h-100 overflow-hidden flexbox-column"></app-view-schedule>
        </div>
    </mat-drawer-content>

    <mat-drawer #drawer class="order-2" style="width: 600px;">
        <div class="toogle-button-block button-block-right">
            <button mat-button class="button-small-icon toogle-button" (click)="drawer.toggle()"></button>
            <div class="toogle-content d-flex">
                <h6 class="title">Preview</h6>
            </div>
        </div>
        <div class="content-block w-100">
            <app-preview-schedule ></app-preview-schedule>
        </div>
    </mat-drawer>
</mat-drawer-container>
